import { useContext } from 'react';
import { MediaQueryContext } from '@polestar/component-warehouse-react/contexts/mediaQuery';
/**
 *
 * Can be used to check for a breakpoint inside a component. This returns an object with boolean on breakpoint names and a list of breakpoints it hit.
 * Because our grid and breakpoint system can only have 1 breakpoint active at a time, only 1 item in the object and list are true.
 *
 * ```js
 * import { useMediaQuery } from '@polestar/component-warehouse-react';
 *
 * const MyComponent = () => {
 *    const { queryMatches, querySizes, name } = useMediaQuery();
 *    queryMatches // { mobile: false, tablet: false, desktop: true, desktopWide: false, }
 *    querySizes // ['desktop']
 *    name // 'desktop'
 *
 *    return ...
 * }
 * ```
 *
 * ## Note
 *
 * Whenever you need mediaquery-information in a parent and a child component, use only once and propagate the values to the child component from the parent component. To prevent unnecessary re-renders and help with debugging mediaquery issues.
 *
 * @storybook Hooks/useMediaQuery
 *
 */
const useMediaQuery = () => useContext(MediaQueryContext);
export default useMediaQuery;
